import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { Loader } from "react-overlay-loader";
import { Link, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import Header2 from '../Layout/Header2';
import icon2 from "../assets/images/gradienticon.png";
import icon1 from "../assets/images/whiteicon.png";
import { axiosInstance } from '../config/https';

export default function Pricing() {
    const [getpackages, setGetpackages] = useState([]);
    const [open, setOpen] = useState(false);
    const [loader, setLoader] = useState(false);

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let query = useQuery();

    useEffect(() => {
        if (query.get('package_id')) {
            buyPackage(query);
        }
    }, [query])

    useEffect(() => {
        GetPackages()
    }, []);

    const handleClose = () => {
        setOpen(false);
    }

    // GET PACKAGES 
    const GetPackages = () => {
        setLoader(true);
        axiosInstance.get("user/GetPakages")
            .then((response) => {
                const Data = response.data;
                setLoader(false);
                if (Data?.status) {
                    setGetpackages(Data.data);
                } else {
                    toast.warn(Data.message);
                }
            }).catch((err) => {
                setLoader(false);
                toast.error(err.message);
            })
    }


    // BUY PACKAGE 
    const packagePayment = (packageDetail) => {
        setLoader(true);
        handleClose();
        const formData = new FormData();
        formData.append('package', packageDetail.id)
        formData.append('amount', packageDetail.package_price)
        formData.append('description', packageDetail.package_duration)
        formData.append('currency', packageDetail.package_currency)

        axiosInstance.post("/user/Getpaymenturl", formData)
            .then((response) => {
                const Data = response?.data;
                setLoader(false);
                if (Data?.status) {
                    toast.success(Data?.message);
                    console.log('resp', Data);
                    window.open(Data.payment_url, "_self");
                    // const Token = localStorage.getItem("Token");
                    // if (Token) {
                    //     const urlWithToken = `https://admin-the-next-photo.vercel.app/userpricing?token=${Token}&package_id=${packid}`;
                    //     window.open(urlWithToken, "_self");
                    // } else {
                    //     console.log("Token not found in local storage.");
                    //     window.open("http://localhost:3000/userlogin", "_self")
                    // }
                } else {
                    toast.warn(Data?.message);
                }
            }).catch((err) => {
                setLoader(false);
            })
    }

    const buyPackage = (packageDetail) => {
        setLoader(true);
        const formData = new FormData();
        formData.append('package', packageDetail.get('package_id'))
        formData.append('amount', packageDetail.get('amount'))
        formData.append('description', packageDetail.get('description'))
        formData.append('currency', packageDetail.get('currency'))

        axiosInstance.post("/user/create_payment", formData)
            .then((response) => {
                const Data = response?.data;
                setLoader(false);
                if (Data?.status) {
                    toast.success(Data?.message);
                    const Token = localStorage.getItem("Token");
                    if (Token) {
                        const urlWithToken = `${Data.user_panel}?token=${Token}&package_id=${packageDetail.get('package_id')}`;
                        setTimeout(() => {
                            window.open(urlWithToken, "_self");
                        }, 2000);
                    } else {
                        console.log("Token not found in local storage.");
                        window.open("http://localhost:3000/userlogin", "_self")
                    }
                } else {
                    toast.warn(Data.message);
                }
            }).catch((err) => {
                setLoader(false);
                console.log('err', err);
                toast.error(err.message);
            })
    }

    return (
        <div>
            <Header2 />
            {loader === true ? <Loader fullPage loading /> : null}
            <section className="section bg-gradient-new pricing" id="pricing">
                <div className="container">
                    <div className="row gy-5 justify-content-center">
                        <div className="col-lg-10">
                            <div className="text-center">
                                <p className="price">High-quality headshots, no premium price.</p>
                                <p className="craft1"> Upgrade your Linkedin presence, supercharge job applications, or elevate your company's
                                    <br />   website with our tailored headshot packages.  </p>
                            </div>
                        </div>
                        {/* End col */}
                        {getpackages.map((v, i) => {
                            return (
                                <div className="col-lg-4 col-md-6" key={i}>
                                    <div className="  pricebg h-100">
                                        <div className="" style={{ padding: "20px 20px " }}>
                                            <p className="packname">{v.package_name}</p>
                                            <p className="packprice">
                                                {v.package_currency}{v.package_price}
                                            </p>
                                        </div>
                                        <div style={{ padding: "0 20px " }}>

                                            <p className="packdes"> {v.package_desc} </p>
                                        </div>
                                        <div className="pb-0" style={{ padding: "20px 20px " }}>
                                            <ul className="list-unstyled">
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shring-0">
                                                            <img src={icon2} alt='' />
                                                        </div>
                                                        <div className="flex-grow-1 ms-2">
                                                            <span className='packlist'>  Package Duration: {v.package_duration} </span>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shring-0">
                                                            <img src={icon2} alt='' />
                                                        </div>
                                                        <div className="flex-grow-1 ms-2">
                                                            <span className='packlist'>  ultra-realistic headshots: {v.ultra_realistic_headsets} </span>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shring-0">
                                                            {v.unlimited_styles === false ? <img src={icon1} alt='' /> : <img src={icon2} alt='' />
                                                            }

                                                        </div>
                                                        <div className="flex-grow-1 ms-2">
                                                            <span className='packlist'>Unlimited styles </span>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shring-0">
                                                            <img src={icon2} alt='' />

                                                        </div>
                                                        <div className="flex-grow-1 ms-2">
                                                            <span className='packlist'>package_pixel: {v.package_pixel}px  </span>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shring-0">
                                                            {v.turn_around_time === false ? <img src={icon1} alt='' /> : <img src={icon2} alt='' />}

                                                        </div>
                                                        <div className="flex-grow-1 ms-2">
                                                            <span className='packlist'>  turnaround time </span>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shring-0">
                                                            {v.non_refundable === false ? <img src={icon1} alt='' /> : <img src={icon2} alt='' />}

                                                        </div>
                                                        <div className="flex-grow-1 ms-2">
                                                            <span className='packlist'> Non-refundable </span>

                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shring-0">
                                                            {v.no_human_edits === false ? <img src={icon1} alt='' /> : <img src={icon2} alt='' />}

                                                        </div>
                                                        <div className="flex-grow-1 ms-2">
                                                            <span className='packlist'> No human edits </span>

                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="row pb-4 justify-content-center">
                                            <div className='col-md-10'>
                                                <Link to="#" onClick={() => packagePayment(v)}>
                                                    <div className="pricebd">
                                                        <spna className="pricebts">
                                                            Create Yours Now
                                                            <span className='mx-1'>  <BsArrowRight size={15} color='#fff'/></span>
                                                        </spna>
                                                    </div>
                                                </Link>
                                                {/* <Link className="w-75 btn btn-outline-primary1"
                                                to="#"
                                                onClick={() => handleClickOpen(v.id)}
                                                >
                                                Create Yours Now
                                                <span className='mx-1'>  <BsArrowRight size={15}/></span>
                                            </Link> */}
                                            </div>

                                        </div>
                                    </div>
                                    {/* End card */}
                                </div>
                            )}
                        )}
                    </div>
                    {/* End row */}
                </div>
                {/* End container */}
            </section>

            {/* modal  */}
            <Dialog
                open={open}
                onClose={handleClose}
            // aria-labelledby="alert-dialog-title"
            // aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" className='text-dark'>
                    Are you sure?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <h5>Do you really want to buy this package?</h5>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-warning rounded-pill" onClick={handleClose}>
                        No
                    </button>
                    <button className="btn btn-warning rounded-pill" onClick={() => packagePayment()}>
                        yes
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
